module.exports = __webpack_public_path__ + "d5cd28454c6027a019df82314105e1b8.jpg";